import {
  headerSearchBarFix,
  updateContentMargin,
  modifyFeatureLineup,
  updateCustomSignup,
} from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website');
  updateMenuButton();
  modifyFeatureLineup();
  updateCustomSignup();

  $(globalThis).load(function () {
    setNavItemAttributes();
    updateContentMargin();
  });
});
